// update state
const setRoleNameAction = (payload) => {
    return {
        type: "ROLENAME",
        payload
    }

}

export default setRoleNameAction;




// WEBPACK FOOTER //
// ./src/actions/setRoleNameAction.js